<template>
    <!-- <body class="body-dashboard"> -->
      <!-- <body :class="bodyClass"> -->
      <div>
        <Header @asideIsClick = 'asideIsClick' @impersonateModal = 'impersonateModal'></Header>
        <Aside :active = 'click' :active-mobile = 'click' @asideModal = 'asideModal' @asideClose = 'asideClose'></Aside>
        <main>
            <router-view :key="$route.fullPath"/>
        </main>
        <div :class="{'loading': true, 'active': this.$store.state.isLoading}">
          <div class="icon"><i class="fa fa-circle-o-notch fa-spin"></i></div>
        </div>
        <Modal v-show="modalShow" @asideModal = 'asideModal'></Modal>
        <ImpersonateModal v-show="impersonateModalShow" @impersonateModal = 'impersonateModal'></ImpersonateModal>
    </div>
    <!-- </body> -->
</template>

<script>
import Header from '@/components/Header.vue'
import Aside from '@/components/Aside.vue'
import Modal from '@/components/Modal.vue'
import ImpersonateModal from '@/components/ImpersonateModal.vue'

export default {
  data: () => ({
    click: false,
    modalShow: false,
    impersonateModalShow: false
  }),
  name: 'Body',
  components: {
    Header,
    Aside,
    Modal,
    ImpersonateModal
  },
  created () {
  },
  methods: {
    // Change button color
    asideIsClick (clickPass) {
      this.click = !clickPass
    },
    asideModal (show) {
      this.modalShow = show
    },
    asideClose (clickPass) {
      this.click = !clickPass
    },
    impersonateModal (show) {
      this.impersonateModalShow = show
    }
  },
  computed: {

  }
}
</script>
